import { uploadComponent } from './upload.component';

export const uploadStateName = 'app.ticket.upload';

export const uploadState = ($stateProvider) => {
  'ngInject';

  $stateProvider.state({
    name: 'app.ticket.upload',
    url: '/upload',
    component: uploadComponent.name,
    data: { requiresAuth: true },
    resolve: {
      maybeRedirectToNewUi: (appConfig, $window, envService) => {
        const { ui } = appConfig;
        if (ui.v2UI.oldBank && !envService.isLocalhost()) {
          $window.location.href = $window.location.href.replace(
            '/tickets',
            '/v2/tickets',
          );
        }
      },
    },
  });
};
